import { LoginComponent } from './login/login.component';
import { Routes } from '@angular/router';

export const loginRoutes: Routes = [
	{
		path: 'login',
		component: LoginComponent
	}
];



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/login/login.routes.ts